const mainBody = document.querySelector('body');

function getCSSVar(name) {
  return parseFloat(getComputedStyle(document.documentElement).getPropertyValue(name)) || 0;
}

function checkScrollThreshold() {
  const target =  document.querySelector('.easysearch-block-container');

console.log(target, 'SearchTarget')
  const scrollY = window.scrollY;
  const headerHeight = getCSSVar('--header-height');
  const heroHeight = getCSSVar('--hero-height');
  const threshold = headerHeight + heroHeight - 30;
 
 
  if (!target) return;

  if (scrollY > threshold) {
    mainBody.classList.add('with-ymm');
    target.classList.add('scrolled');
  } else {
      mainBody.classList.remove('with-ymm');
    target.classList.remove('scrolled');
  }
} 

window.addEventListener('scroll', checkScrollThreshold);

/* REMOVE 'SELECT' FROM DROP DOWNS */
document.querySelectorAll('.easysearch-block-container select option').forEach((option) => {
  const text = option.textContent.trim();
  if (text.toLowerCase().startsWith('select ')) {
    option.textContent = text.replace(/^select\s+/i, '');
  }
});

/* CREATE RESET BUTTON */
function injectResetButton() {
  const actionsHolder = document.querySelector('.easysearch-holder');
  const yearSelect = document.querySelector('#easysearch_field_2899');
  const mainWidget = document.querySelector('.easysearch-main-widget'); // add this

  console.log(actionsHolder, 'ACTION HOLDER');
  if (!actionsHolder || !yearSelect) return;    

  // Avoid injecting multiple times
  if (actionsHolder.querySelector('.easysearch-btn-reset')) return;

  const resetBtn = document.createElement('button');
  resetBtn.textContent = 'Reset ↺';
  resetBtn.className = 'easysearch-btn easysearch-btn-reset';
  resetBtn.type = 'button';
  resetBtn.style.marginLeft = '1rem';

  resetBtn.addEventListener('click', () => {
    // reset the select
    yearSelect.selectedIndex = 0;
    yearSelect.dispatchEvent(new Event('change', { bubbles: true }));

    // also remove searched class from main widget
    if (mainWidget) {
      mainWidget.classList.remove('searched');
    }
  });

  actionsHolder.appendChild(resetBtn);
}


injectResetButton();



const bulbSelect = document.querySelector('.easysearch-select-holder-last select');
const mainWidget = document.querySelector('.easysearch-main-widget');

if (bulbSelect && mainWidget) {
  function updateClass() {
    if (bulbSelect.value && bulbSelect.value.trim() !== "") {
      mainWidget.classList.add('searched');
    } else {
      mainWidget.classList.remove('searched');
    }
  }

  // Run once on load
  updateClass();

  // Update on change
  bulbSelect.addEventListener('change', updateClass);
}
